<div class="ltl-settings" [formGroup]="form">
    <div class="ltl-settings__controls">
        <button type="button"
                mat-stroked-button
                color="primary"
                (click)="addRule()"
                [disabled]="saving">
            Add rule
        </button>
    </div>

    <ng-container formArrayName="rules">
        <mat-card class="ltl-settings__rule-card"
                  *ngFor="let ruleGroup of rules.controls; let i = index; trackBy: trackRule"
                  [formGroupName]="i">
            <mat-card-header>
                <mat-card-title>
                    Rule {{ i + 1 }}
                </mat-card-title>
                <div class="ltl-settings__rule-header-actions">
                    <button mat-icon-button
                            type="button"
                            color="warn"
                            (click)="removeRule(i)"
                            [disabled]="saving"
                            matTooltip="Remove rule">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </mat-card-header>

            <mat-card-content>
                <div class="ltl-settings__row">
                    <mat-form-field class="full">
                        <mat-label>Select hubs</mat-label>
                        <mat-select formControlName="hubs" multiple>
                            <mat-select-trigger>
                                <span *ngIf="ruleGroup.get('hubs')?.value?.length">
                                    {{ ruleGroup.get('hubs')?.value?.length }} hub(s) selected
                                </span>
                                <span *ngIf="!ruleGroup.get('hubs')?.value?.length">Select hubs</span>
                            </mat-select-trigger>
                            <mat-option>
                                <ngx-mat-select-search [formControl]="getHubSearchControl(i)"
                                                       placeholderLabel="Search hubs..."
                                                       noEntriesFoundLabel="No hubs found"></ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngIf="loading.hubs" disabled>Loading hubs...</mat-option>
                            <mat-option *ngIf="!loading.hubs && !getFilteredHubs(i).length" disabled>
                                No hubs available
                            </mat-option>
                            <mat-option *ngFor="let hub of getFilteredHubs(i)" [value]="hub.id">
                                {{ hub.customers_inventory_name }}
                                <span *ngIf="hub.customers_sub_inventory || hub.sub_inventory">
                                    / {{ hub.customers_sub_inventory || hub.sub_inventory }}
                                </span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="ltl-settings__row">
                    <mat-form-field class="full">
                        <mat-label>Select package types</mat-label>
                        <mat-select formControlName="packageTypes" multiple>
                            <mat-select-trigger>
                                <span *ngIf="ruleGroup.get('packageTypes')?.value?.length">
                                    {{ ruleGroup.get('packageTypes')?.value?.length }} type(s) selected
                                </span>
                                <span *ngIf="!ruleGroup.get('packageTypes')?.value?.length">Select package types</span>
                            </mat-select-trigger>
                            <mat-option *ngIf="loading.packageTypes" disabled>Loading package types...</mat-option>
                            <mat-option *ngIf="!loading.packageTypes && !packageTypes.length" disabled>
                                No package types available
                            </mat-option>
                            <mat-option *ngFor="let type of packageTypes" [value]="type.id">
                                {{ type.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="ltl-settings__row ltl-settings__row--inline">
                    <mat-checkbox formControlName="setOnHold">
                        Set on hold
                    </mat-checkbox>
                </div>

                <div class="ltl-settings__row">
                    <mat-form-field class="full">
                        <mat-label>Remark message</mat-label>
                        <textarea matInput rows="2" formControlName="remark"></textarea>
                    </mat-form-field>
                </div>
            </mat-card-content>
        </mat-card>
    </ng-container>

    <div *ngIf="!rules.controls.length" class="ltl-settings__empty">
        <p>No LTL rules configured.</p>
        <button type="button"
                mat-stroked-button
                color="primary"
                (click)="addRule()"
                [disabled]="saving">
            Add first rule
        </button>
    </div>

    <div class="ltl-settings__actions">
        <span class="spacer"></span>
        <button type="button"
                mat-raised-button
                color="primary"
                (click)="save()"
                [disabled]="saving || (form.pristine && !!rules.controls.length)">
            Save
        </button>
    </div>
</div>

